module.exports = __webpack_public_path__ + "static/img/HAMBURG-MAPLE.3f2c4e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/HAMBURG-MAPLE.png
// module id = 0lGP
// module chunks = 0